import React from 'react';
import * as S from './styles';

export default function FloatBox() {
  return <S.Box>Desenvolva OEDs de forma simples e acessível</S.Box>;
}
